module.exports = __webpack_public_path__ + "img/1.4f3b7653.png";